// extracted by mini-css-extract-plugin
export default {"outlet":"running_outlet__DR0dY","title":"running_title__d15Oj","progress":"running_progress__mSXoG","workspace":"running_workspace__kho8J"};